












import { Component, Vue } from 'vue-property-decorator'

import { Meta } from '@/helpers/decorators'
import ReportsList from '@/views/reports/list/ReportsList.vue'
import Tabs from '@/components/common/Tabs.vue'

@Component({
  components: {
    ReportsList,
    Tabs
  }
})
export default class ListFinishedReports extends Vue {
  @Meta
  metas() {
    return {
      title: this.$t('menu.reports'),
      titleTemplate: `${this.$t('reports.state.finished')} - %s - ${process.env.VUE_APP_NAME}`
    }
  }
}
